import '../components/product-highlight';

// Adds a subtle parallax effect to the header background color
(function () {
  var elms = document.getElementsByClassName('blog-post-parallax-effect');
  if (elms.length == 0) {
    return;
  }
  var headerBackground = elms[0];
  document.addEventListener('scroll', function () {
    headerBackground.style.bottom =
      'calc(50% - ' + window.pageYOffset / 4 + 'px)';
  });
})();

// Check if we have consent to load social media features
(function () {
  if (window.cookies.hasConsent(window.cookies.CONSENT_SOCIALMEDIA)) {
    loadEmbeds();
  } else {
    window.cookies.addEventListener(
      'consent',
      function ({ detail: { levels } }) {
        if (levels.includes(window.cookies.CONSENT_SOCIALMEDIA)) {
          loadEmbeds();
        }
      }
    );
  }
})();

function loadEmbeds() {
  loadYoutubeEmbeds();
  loadInstagramEmbeds();
}

function loadYoutubeEmbeds() {
  var embeds = [...document.getElementsByClassName('youtube-embed')];
  if (embeds.length === 0) {
    return;
  }
  embeds.forEach(embed => {
    var youtubeId = embed.getAttribute('data-youtube-id');
    embed.addEventListener('click', function () {
      embed.classList.remove('img-mode');
      embed.innerHTML = `<iframe src="//www.youtube.com/embed/${youtubeId}?autoplay=1" width="100%" height="412 p" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`;
    });
  });
}

function loadInstagramEmbeds() {
  const embeds = [...document.getElementsByClassName('instagram-embed')];
  if (embeds.length === 0) {
    return;
  }
  const instagramScript = document.createElement('script');
  instagramScript.id = 'instagram-script';
  instagramScript.setAttribute('src', '//www.instagram.com/embed.js');
  document.body.appendChild(instagramScript);
}
